export default "__VITE_ASSET__c915eb20__"